import { SpecialClassNames } from '@acceso/design-system';

/**
 * Row classes for the schedule list.
 *
 * Constant on purpose. The reviewer-presence highlight used to be resolved here
 * from the presence map, which meant the table had to subscribe to presence and
 * re-render — losing, among other transient state, a date range the user had
 * chosen but not applied. The row now carries the highlight rule itself and CSS
 * turns it on when the row contains a `data-reviewer-occupied` marker, which
 * `ProgramBroadcastReviewers` renders from its own subscription.
 */
export function getProgramBroadcastSpecialClassNames(): SpecialClassNames {
  return {
    row: 'reviewer-occupied-row',
  };
}
